import { render, staticRenderFns } from "./StockPL.vue?vue&type=template&id=2867cd3d&"
import script from "./StockPL.vue?vue&type=script&lang=ts&"
export * from "./StockPL.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports